(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["descriptions-library"] && !Shopify.designMode) return;
  try {
    
  class DescriptionsLibrary {
    constructor(section) {
      if (section.dataset.bdmResourceLibraryInitialized === 'true') {
        return;
      }

      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-brand][role="tab"]'));
      this.cards = Array.from(section.querySelectorAll('[data-resource-card]'));
      this.emptyMessage = section.querySelector('[data-empty-message]');
      this.activeClass = 'is-active';
      section.dataset.bdmResourceLibraryInitialized = 'true';

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectBrand(tab.dataset.brand));
      });

      const defaultTab = this.tabs.find((tab) => tab.classList.contains(this.activeClass)) || this.tabs[0];

      if (defaultTab) {
        this.selectBrand(defaultTab.dataset.brand);
      }
    }

    selectBrand(brand) {
      let visibleCount = 0;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.brand === brand;
        tab.classList.toggle(this.activeClass, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.cards.forEach((card) => {
        const isVisible = card.dataset.brand === brand;
        card.hidden = !isVisible;
        card.classList.toggle('is-hidden', !isVisible);

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (this.emptyMessage) {
        this.emptyMessage.hidden = visibleCount > 0;
      }
    }
  }

  const initBdmResourceLibraries = (root = document) => {
    if (root.matches && root.matches('[data-descriptions-library]')) {
      new DescriptionsLibrary(root);
    }

    root.querySelectorAll('[data-descriptions-library]').forEach((section) => {
      new DescriptionsLibrary(section);
    });
  };

  initBdmResourceLibraries();

  document.addEventListener('shopify:section:load', (event) => {
    initBdmResourceLibraries(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        this.getAttribute('data-sticky-type') === 'absolute';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-resource-library"] && !Shopify.designMode) return;
  try {
    
  function initResourceLibrary(root) {
    if (root.dataset.initialized || !root.querySelector('[data-resource-grid]')) return;
    root.dataset.initialized = 'true';
    const cards = Array.from(root.querySelectorAll('[data-folder], [data-file]'));
    const folders = cards.filter(card => card.hasAttribute('data-folder'));
    const files = cards.filter(card => card.hasAttribute('data-file'));
    const paths = new Set(folders.map(card => card.dataset.folder));
    const input = root.querySelector('[data-resource-search]');
    const breadcrumb = root.querySelector('[data-resource-breadcrumb]');
    const heading = root.querySelector('[data-resource-heading]');
    const status = root.querySelector('[data-resource-status]');
    const rootTitle = root.dataset.rootTitle;
    const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`;
    const folderHref = path => '#folder=' + encodeURIComponent(path);
    folders.forEach(folder => {
      const prefix = folder.dataset.folder;
      const count = files.filter(file => file.dataset.parent === prefix || file.dataset.parent.startsWith(prefix + '/')).length;
      folder.querySelector('[data-folder-count]').textContent = plural(count, 'file');
    });
    root.querySelector('[data-search-controls]').hidden = false;
    root.querySelector('[data-view-head]').hidden = false;
    function render(focus = false) {
      const requested = new URLSearchParams(location.hash.slice(1)).get('folder') || '';
      const current = paths.has(requested) ? requested : '';
      const query = input.value.trim().toLocaleLowerCase();
      let fileCount = 0, folderCount = 0;
      cards.forEach(card => {
        const match = query ? (card.dataset.title + ' ' + (card.dataset.filename || '') + ' ' + card.dataset.parent).toLocaleLowerCase().includes(query) : card.dataset.parent === current;
        card.hidden = !match;
        if (match) card.hasAttribute('data-file') ? fileCount++ : folderCount++;
        const context = card.querySelector('.pg-r-file-path');
        if (context) context.hidden = !query;
      });
      heading.textContent = query ? 'Search results' : current.split('/').pop() || (folderCount ? 'Folders' : 'Files');
      status.textContent = [folderCount ? plural(folderCount, 'folder') : '', fileCount || !folderCount ? plural(fileCount, 'file') : ''].filter(Boolean).join(' · ');
      root.querySelector('[data-resource-empty]').hidden = Boolean(fileCount || folderCount);
      breadcrumb.replaceChildren();
      breadcrumb.hidden = !current;
      const parts = current ? current.split('/') : [];
      [rootTitle, ...parts].forEach((part, index, all) => {
        if (index) { const divider = document.createElement('span'); divider.textContent = '/'; divider.setAttribute('aria-hidden', 'true'); breadcrumb.append(divider); }
        const item = document.createElement(index === all.length - 1 ? 'span' : 'a');
        item.textContent = part;
        if (item.tagName === 'A') item.href = folderHref(parts.slice(0,index).join('/'));
        else item.setAttribute('aria-current','page');
        breadcrumb.append(item);
      });
      if (focus) heading.focus({preventScroll: true});
    }
    const selectBlock = event => {
      const card = cards.find(item => item.dataset.blockId === event.detail.blockId);
      if (!card) return;
      input.value = '';
      history.replaceState(null, '', folderHref(card.dataset.parent));
      render();
      card.scrollIntoView({block: 'center', behavior: 'instant'});
    };
    document.addEventListener('shopify:block:select', selectBlock);
    input.addEventListener('input', () => render());
    root.querySelector('[data-clear-search]').addEventListener('click', () => { input.value = ''; render(); input.focus(); });
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#folder="]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      input.value = '';
      history.pushState(null, '', link.getAttribute('href'));
      render(true);
    });
    const navigate = () => { input.value = ''; render(true); };
    window.addEventListener('popstate', navigate);
    window.addEventListener('hashchange', navigate);
    root.querySelectorAll('.pg-r-preview img').forEach(img => {
      const fallback = () => { img.hidden = true; const label = document.createElement('span'); label.className = 'pg-r-meta'; label.textContent = 'Image preview unavailable'; img.parentElement.append(label); };
      img.addEventListener('error', fallback, {once:true});
      if (img.complete && !img.naturalWidth) fallback();
    });
    render();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { window.removeEventListener('popstate', navigate); window.removeEventListener('hashchange', navigate); document.removeEventListener('shopify:block:select', selectBlock); }
    });
  }
  document.querySelectorAll('[data-resource-library]').forEach(initResourceLibrary);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-resource-library]').forEach(initResourceLibrary));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["point-of-sale-library"] && !Shopify.designMode) return;
  try {
    
  class BdmResourceLibrary {
    constructor(section) {
      if (section.dataset.bdmResourceLibraryInitialized === 'true') {
        return;
      }

      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-brand][role="tab"]'));
      this.cards = Array.from(section.querySelectorAll('[data-resource-card]'));
      this.emptyMessage = section.querySelector('[data-empty-message]');
      this.activeClass = 'is-active';
      section.dataset.bdmResourceLibraryInitialized = 'true';

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectBrand(tab.dataset.brand));
      });

      const defaultTab = this.tabs.find((tab) => tab.classList.contains(this.activeClass)) || this.tabs[0];

      if (defaultTab) {
        this.selectBrand(defaultTab.dataset.brand);
      }
    }

    selectBrand(brand) {
      let visibleCount = 0;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.brand === brand;
        tab.classList.toggle(this.activeClass, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.cards.forEach((card) => {
        const isVisible = card.dataset.brand === brand;
        card.hidden = !isVisible;
        card.classList.toggle('is-hidden', !isVisible);

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (this.emptyMessage) {
        this.emptyMessage.hidden = visibleCount > 0;
      }
    }
  }

  const initBdmResourceLibraries = (root = document) => {
    if (root.matches && root.matches('[data-bdm-resource-library]')) {
      new BdmResourceLibrary(root);
    }

    root.querySelectorAll('[data-bdm-resource-library]').forEach((section) => {
      new BdmResourceLibrary(section);
    });
  };

  initBdmResourceLibraries();

  document.addEventListener('shopify:section:load', (event) => {
    initBdmResourceLibraries(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
